var map = {
	"./MasterStore.js": 1283,
	"./index.js": 684
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1282;


//////////////////
// WEBPACK FOOTER
// ./src/store/modules nonrecursive \.js$
// module id = 1282
// module chunks = 37